{
  "close": "Cerrar",
  "sidebar": {
    "toggle": "Alternar barra lateral",
    "title": "Barra lateral",
    "description": "Muestra la barra lateral móvil."
  }
}
